import React from 'react';
import Counter from '../../components/Counter';

import funFactBG from '../../assets/img/funfact/funfact-bg.png';

const FunFact = () => {
  const counters = [
    {
      countIcon: 'flaticon-teacher',
      countNum: 500,
      countSubtext: '+',
      countTitle: 'Life Members',
    },
    {
      countIcon: 'flaticon-completed-task',
      countNum: 21,
      countSubtext: '+',
      countTitle: 'Year Of Service',
    },
    {
      countIcon: 'flaticon-customer-review',
      countNum: 300,
      countSubtext: '+',
      countTitle: 'Students Reached',
    },
    {
      countIcon: 'flaticon-class',
      countNum: 10,
      countSubtext: '+',
      countTitle: 'Field of Work',
    },
  ];
  return (
    <div className={'it-funfact-area z-index-5'}>
      <div className="container">
        <div
          className={'it-funfact-bg-wrap yellow-bg'}
          style={{ backgroundImage: `url(${funFactBG})` }}
        >
          <div className="row gx-0">
            {counters.map((counter, index) => (
              <div key={index} className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="it-funfact-item d-flex align-items-center">
                  <div className="it-funfact-icon">
                    <span>
                      <i className={counter.countIcon}></i>
                    </span>
                  </div>
                  <div className="it-funfact-content">
                    <h6>
                      <Counter
                        start={0}
                        end={counter.countNum}
                        duration={5}
                        counterSubText={counter.countSubtext}
                      />
                    </h6>
                    <span className="it-funfact-content-title">
                      {counter.countTitle}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default FunFact;
